module.exports = __webpack_public_path__ + "assets/img/map.9ebc81dc.png";